import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ProductPriceRangeFragment = { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } };

export const ProductPriceRangeFragmentDoc = gql`
    fragment ProductPriceRangeFragment on ProductPriceRangeType {
  id
  currency
  discount {
    max
    min
  }
  undiscount {
    max
    min
  }
}
    `;